export default "__VITE_ASSET__BdQKdsdv__"